import { createApiRef, DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { MSDefenderSecurityMetrics, MSDefenderMetricsSnapshot } from '@zeiss/plugin-ms-defender-common';

export const msDefenderApiRef = createApiRef<MsDefenderApi>({
  id: 'plugin.ms-defender',
});

/**
 * API client for MS Defender security metrics.
 * Backend queries the Azure Resource Graph API:
 * https://learn.microsoft.com/en-us/javascript/api/overview/azure/resource-graph
 */
export interface MsDefenderApi {
  getMetrics(subscriptionId: string): Promise<MSDefenderSecurityMetrics>;
  getHistory(subscriptionId: string, days?: number): Promise<MSDefenderMetricsSnapshot[]>;
}

export class MsDefenderClient implements MsDefenderApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getMetrics(subscriptionId: string): Promise<MSDefenderSecurityMetrics> {
    const baseUrl = await this.discoveryApi.getBaseUrl('ms-defender');
    const response = await this.fetchApi.fetch(`${baseUrl}/metrics?subscriptionId=${encodeURIComponent(subscriptionId)}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch metrics: ${response.statusText}`);
    }
    return response.json();
  }

  async getHistory(subscriptionId: string, days = 90): Promise<MSDefenderMetricsSnapshot[]> {
    const baseUrl = await this.discoveryApi.getBaseUrl('ms-defender');
    const response = await this.fetchApi.fetch(
      `${baseUrl}/history?subscriptionId=${encodeURIComponent(subscriptionId)}&days=${days}`,
    );
    if (!response.ok) {
      throw new Error(`Failed to fetch history: ${response.statusText}`);
    }
    return response.json();
  }
}